import withQuery from './withQuery';
export default withQuery;
//# sourceMappingURL=index.js.map